import { render, staticRenderFns } from "./SelectVhisTemplate.vue?vue&type=template&id=85b90b60"
import script from "./SelectVhisTemplate.vue?vue&type=script&lang=js"
export * from "./SelectVhisTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports